module.exports = __webpack_public_path__ + "media/images/Image-2392cf341d476cc8294e59896018360d.png";